import React from 'react';

// import * as Sentry from '@sentry/browser';
// import { Integrations } from '@sentry/tracing';
import { Navbar } from 'react-bootstrap';
import { Routes, Route, BrowserRouter } from 'react-router-dom';

import Footer from '@components/Footer';
import Logo from '@components/Logo';
import MainMenu from '@components/MainMenu';
import PageLoader from '@components/PageLoader';
import ProtectedRouteWrapper from '@components/ProtectedRouteWrapper';
import TopInfoBanner from '@components/TopInfoBanner';

import { AuthContext } from './contexts/AuthContext';
import routes from './routes';

const App = () => {
  const authContext = React.useContext(AuthContext);

  function getRoutes() {
    return routes.map((route) => {
      return (
        <Route
          key={route.path}
          path={route.path}
          Component={() => (
            <ProtectedRouteWrapper
              title={route.title}
              needAuth={!!route.protected}
              componentRender={route.component}
            />
          )}
        />
      );
    });
  }

  if (authContext.loading) {
    return <PageLoader />;
  }
  // Sentry.init({
  //   dsn: 'https://531ca6cb6ae64d6da044112cfaf23b41@o970824.ingest.sentry.io/5922343',
  //   integrations: [new Integrations.BrowserTracing()],
  //   tracesSampleRate: 0.5,
  // });
  return (
    <BrowserRouter>
      <TopInfoBanner id="new_domain_notification">
        Домен pohodnik.tk, на котором долгое время жил сайт Походников, больше недоступен.
        <br />
        Возвращаемся к истокам — <b className="text-success">pohodnik58.ru</b>.
      </TopInfoBanner>
      <div className="container" style={{ background: '#fff' }}>
        <Navbar
          bg="light"
          className="justify-content-between pt-3 pb-3 align-items-center bg-white d-print-none"
          id="banner"
          expand="md"
        >
          <Navbar.Brand href="/">
            <Logo />
          </Navbar.Brand>

          <Navbar.Toggle
            className="btn btn-primary d-sm-none d-block"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight"
            aria-controls="offcanvasRight"
          />

          <div
            className="offcanvas offcanvas-end  d-sm-none d-block"
            tabIndex={-1}
            id="offcanvasRight"
            aria-labelledby="offcanvasRightLabel"
          >
            <div className="offcanvas-header">
              <Logo />
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body" data-bs-dismiss="offcanvas">
              <MainMenu />
            </div>
          </div>

          <Navbar.Collapse
            id="basic-navbar-nav"
            className="d-flex justify-content-end float-end d-none d-sm-flex"
          >
            <MainMenu />
          </Navbar.Collapse>
        </Navbar>
        <div role="main" className="flex-grow-1">
          <Routes>{getRoutes()}</Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;
